/**
 * @fileoverview Hook for fetching promo cards
 */

import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

export interface PromoCard {
  id: string;
  title: string;
  description: string;
  badge_text: string | null;
  cta_text: string | null;
  link_url: string | null;
  image_url: string | null;
  is_active: boolean;
  position: number;
  created_at: string;
}

export function usePromoCards() {
  return useQuery({
    queryKey: ['promo-cards'],
    queryFn: async () => {
      const { data, error } = await (supabase
        .from('promo_cards' as any)
        .select('*')
        .eq('is_active', true)
        .order('position', { ascending: true }) as any);

      if (error) throw error;
      return data as PromoCard[];
    },
    staleTime: 5 * 60 * 1000, // Cache for 5 minutes
  });
}
